/**
 * @hidden
 */
export const APP_VERSION = '##APP_VERSION##'
/**
 * @hidden
 */
export const APP_GLOBAL = '##APP_GLOBAL##'

/**
 * Global Variable Name of IBSheet
 */
export const IBSHEET_GLOBAL = 'IBSheet'

/**
 * Unique Name for IBSheet
 */
export const IBSHEET = 'ibsheet'
